function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawArt = function UndrawArt(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1127.558 833.655",
    style: style
  }, props), React.createElement("path", {
    d: "M664.015 134.626v416.99a18.694 18.694 0 0 1-18.694 18.693H44.494a13.177 13.177 0 0 1-13.178-13.177V186.127a84.836 84.836 0 0 1 84.837-84.837h514.526a33.336 33.336 0 0 1 33.336 33.336z",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    d: "M440.882 474.157a217.016 217.016 0 0 1-22.306 96.152H44.494a13.177 13.177 0 0 1-13.178-13.177V370.048a218.005 218.005 0 0 1 409.566 104.109z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M664.015 439.366v112.25a18.694 18.694 0 0 1-18.694 18.693H43.665a13.083 13.083 0 0 1-13.083-13.079v-.133c0-93.495 290.8-173.243 373.483-204.21a218.26 218.26 0 0 1 259.95 86.479z",
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 564.926,
    cy: 229.738,
    r: 54.315,
    fill: "#ff6584"
  }), React.createElement("path", {
    d: "M281.361 242.2c0 105.95-62.984 142.943-140.68 142.943S0 348.149 0 242.2 140.68 1.468 140.68 1.468 281.362 136.252 281.362 242.2z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M135.556 368.936l1.441-88.67 59.961-109.697-59.736 95.787.648-39.869 41.325-79.365-41.153 68.814 1.164-71.707 44.253-63.184-44.069 51.908.728-131.485-4.575 174.063.376-7.181-44.991-68.866 44.27 82.65-4.192 80.085-.125-2.126-51.867-72.472 51.71 79.982-.524 10.015-.094.151.043.822-10.636 203.181h14.21l1.705-104.947 51.583-79.785-51.455 71.896z"
  }), React.createElement("path", {
    d: "M510.74 193.644c0 85.224-50.665 114.981-113.163 114.981s-113.163-29.757-113.163-114.981S397.577 0 397.577 0s113.162 108.42 113.162 193.644z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M393.454 295.589l1.159-71.326 48.233-88.239-48.051 77.051.521-32.071 33.242-63.841-33.104 55.354.937-57.681 35.596-50.825-35.449 41.755L397.124 0l-3.68 140.015.303-5.776-36.191-55.396 35.61 66.484-3.372 64.419-.1-1.71-41.722-58.296 41.595 64.337-.421 8.056-.076.121.035.662-8.556 163.437h11.431l1.371-84.418 41.494-64.179-41.391 57.833z"
  }), React.createElement("path", {
    d: "M743.87 313.865c0 57.377-34.11 77.41-76.185 77.41s-76.186-20.033-76.186-77.41 76.186-130.368 76.186-130.368 76.185 72.992 76.185 130.368z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M664.909 382.498l.78-48.018 32.472-59.407-32.349 51.874.35-21.592 22.38-42.979-22.287 37.266.631-38.833 23.965-34.217-23.866 28.111.395-71.206-2.478 94.263.204-3.888-24.365-37.295 23.974 44.76-2.27 43.369-.068-1.151-28.088-39.247 28.003 43.314-.284 5.423-.05.082.023.445-5.76 110.032h7.696l.923-56.833 27.935-43.208-27.866 38.935z"
  }), React.createElement("path", {
    d: "M182.232 419.727c-3.372 5.378-7.747 5.252-11.69 2.78s-5.965-6.356-2.593-11.734 14.802-7.744 14.802-7.744 2.852 11.32-.52 16.698zM77.271 434.407c-3.371 5.378-7.746 5.252-11.69 2.78s-5.964-6.356-2.593-11.734 14.803-7.744 14.803-7.744 2.852 11.32-.52 16.698zM449.362 408.535c.624 6.317-2.914 8.893-7.546 9.35s-8.606-1.376-9.23-7.693 6.97-15.182 6.97-15.182 9.182 7.207 9.806 13.525zM328.295 330.18c-3.371 5.379-7.746 5.252-11.69 2.78s-5.964-6.355-2.593-11.734 14.803-7.743 14.803-7.743 2.852 11.32-.52 16.697zM607.211 413.121c-3.372 5.379-7.746 5.252-11.69 2.78s-5.965-6.356-2.593-11.734 14.803-7.743 14.803-7.743 2.852 11.319-.52 16.697z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M1086.87 504.655c0 176.178-79.992 315.163-178.5 319-128.463 5.003-296.357-123.086-178.5-319 90.818-150.968 79.917-319 178.5-319s178.5 142.82 178.5 319z",
    fill: "#f2f2f2"
  }), React.createElement("ellipse", {
    cx: 857.87,
    cy: 816.655,
    rx: 159,
    ry: 17,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M994.362 605.535c.624 6.317-2.914 8.893-7.546 9.35s-8.606-1.376-9.23-7.693 6.97-15.182 6.97-15.182 9.182 7.207 9.806 13.525zM929.271 587.407c-3.371 5.378-7.746 5.252-11.69 2.78s-5.964-6.356-2.593-11.734 14.803-7.744 14.803-7.744 2.852 11.32-.52 16.698z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M925.613 732.767s7.53 32.763 19.259 39.824-28.627 20.45-28.627 20.45-17.564 10.89-22.126 14.827-24.114 12.36-20.892 6.104 8.885-18.153 17.825-28.037 20.694-27.579 10.455-41.36 24.106-11.808 24.106-11.808z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M884.841 334.195l-3.946-1.41s-10.148-1.409-19.451 10.43-30.586 47.782-30.586 47.782l-7.893 18.605 27.908.846 21.001-46.231z",
    fill: "#ff6584"
  }), React.createElement("path", {
    d: "M884.841 334.195l-3.946-1.41s-10.148-1.409-19.451 10.43-30.586 47.782-30.586 47.782l-7.893 18.605 27.908.846 21.001-46.231z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M880.613 620.46s15.927 3.523 13.249 15.786 16.632 28.19 18.464 30.867 4.51 3.806 2.82 7.893 39.323 61.735 31.148 66.95-74.42 25.653-80.34 21.565-10.712-137.846-10.712-137.846z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M880.613 620.46s15.927 3.523 13.249 15.786 16.632 28.19 18.464 30.867 4.51 3.806 2.82 7.893 39.323 61.735 31.148 66.95-74.42 25.653-80.34 21.565-10.712-137.846-10.712-137.846z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M844.39 765.917s-9.867 32.136-3.242 44.117-35.018 3.391-35.018 3.391-20.655.644-26.575 1.772-27.063-1.357-21.144-5.163 16.773-11.276 29.458-15.363 31.714-13.531 29.74-30.586 26.78 1.832 26.78 1.832z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M825.925 444.698a31.065 31.065 0 0 1 18.746-5.779c10.853.423 46.372 8.88 45.385 10.571a35.631 35.631 0 0 1-3.241 4.228s2.255 10.29 1.268 11.276 19.31 24.243 7.47 74.139-10.57 84.427-10.57 84.427 4.791 146.304-8.88 149.264-67.514.986-70.051-4.792 7.752-185.206 7.752-185.206 1.127-90.206 3.805-101.2 8.316-36.928 8.316-36.928z",
    fill: "#2f2e41"
  }), React.createElement("circle", {
    cx: 888.013,
    cy: 283.383,
    r: 33.968,
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M882.868 305.864s21.001 20.579-4.933 36.506c-18.261 11.215 44.116-8.739 44.116-8.739s-12.967-33.123-10.993-40.734-28.19 12.967-28.19 12.967z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M888.083 338s29.176-13.39 33.968-8.597 25.512 24.525 2.96 59.48-26.92 61.17-30.726 64.13-6.202-3.805-6.202-3.805-10.994-10.007-18.182-10.007-37.915 3.383-37.915 3.383l8.598-34.11s-4.229-26.92 10.148-40.31 30.163-35.379 30.163-35.379l8.14-1.487-5.375 6.846s-.792 2.112 4.423-.143z",
    fill: "#ff6584"
  }), React.createElement("path", {
    d: "M965.037 567.475c-58.905-21.514-66.683-64.044-50.906-107.24s49.133-70.703 108.038-49.19 105.274 127.097 105.274 127.097-103.502 50.846-162.406 29.333z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M924.182 460.676l49.005 18.806L1022 535.094l-41.125-52.662 22.035 8.456 35.733 39.091-29.902-36.853 39.63 15.208 26.143 37.433-19.911-35.042 72.955 27.104-95.846-37.888 3.916 1.667 47.424-11.03-54.941 7.83-43.673-18.592 1.207.362 50.824-14.121-54.967 12.509-5.462-2.325-.065-.083-.466-.143-110.803-47.17-2.886 7.9 58.002 22.258 33.884 44.88-29.524-43.207z"
  }), React.createElement("path", {
    d: "M820.992 412.42s-12.544 16.915-4.228 23.257 25.793-4.51 25.793-4.51 40.311 28.048 39.747 11.558-29.458-27.908-29.458-27.908l-19.45.564 2.96-9.726-8.176-.845z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M820.992 412.42s-12.544 16.915-4.228 23.257 25.793-4.51 25.793-4.51 40.311 28.048 39.747 11.558-29.458-27.908-29.458-27.908l-19.45.564 2.96-9.726-8.176-.845z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M905.138 379.862s-79.213 61.03-84.287 39.606c-3.298-13.923-.761-48.207 1.42-70.506a69.107 69.107 0 0 1 20.468-42.801c4.753-4.63 9.16-7.535 11.376-5.37 6.201 6.06-14.518 30.303-14.518 30.303s-3.383 49.19 3.383 54.829c0 0 24.51-23.668 29.592-23.321s32.566 17.26 32.566 17.26z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M957.606 315.146c-6.489-9.768-11.846-25.478-17.627-39.315-1.874-4.484-3.586-9.027-5.262-13.589-3.378-9.194-18.085-21.062-37.347-21.062-22.015 0-39.862 11.078-39.862 20.374 0 7.685 12.204 14.162 28.872 16.177-5.856 13.071-9.384 27.578-9.384 37.415 0 22.26 18.045 12.845 40.305 12.845s52.623 5.697 40.305-12.845z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M922.051 341.806s14.095 35.942-17.618 44.117c0 0-6.202-8.598-16.35-10.008s-19.169-11.98-19.169-11.98 20.72-29.176 36.929-29.74 16.208 7.611 16.208 7.611z",
    fill: "#ff6584"
  }));
};
UndrawArt.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawArt;